import { useEffect, useState } from 'react';

const useCustomUserSelected = (users: any[], initiallyChecked: any[]): any => {
    const [checked, setChecked] = useState(initiallyChecked); //Array of selected individuals
    const [checkedCount, setCheckedCount] = useState(Number); //Array of selected individuals
    const [selectableUsers, setSelectableUsers] = useState([]); //Changes based on filtering and/or contents of initiallyChecked

    const [pageSize, setPageSize] = useState(5);

    //Sort lists
    useEffect(() => {
        let res = checked.sort((a, b) => a.name.localeCompare(b.name));
        setChecked(res);
        setCheckedCount(checked.length);
    }, [checked]);
    const setUsers = (users: any) => {
        setSelectableUsers(users);
    };

    const handleSelection = (selections: any) => {
        setChecked(selections);
    };

    return { checked, checkedCount, pageSize, selectableUsers, setUsers, setPageSize, handleSelection };
};

export default useCustomUserSelected;
